import { XelaColor } from '@/XelaReact'
import React, { FC, useState } from 'react'

const XReadMore: FC<{
  content: string
  limit?: number
  fontSize?: string
  fontColor?: string
  contentHeight?: string
}> = ({ content, limit = 120, fontSize = '14px', fontColor = XelaColor.Gray7, contentHeight = '44px' }) => {
  const [showFullContent, setShowFullContent] = useState(false)
  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          color: fontColor,
          maxHeight: showFullContent ? '100%' : contentHeight,
          overflowY: 'hidden',
          fontSize: fontSize,
        }}
        className="note-content"
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
      {content.length >= limit && (
        <div
          style={{
            position: 'absolute',
            bottom: '-2px',
            cursor: 'pointer',
            right: '-64px',
            fontWeight: 600,
            fontSize: '10px',
            padding: '1px 0 1px 12px',
            backgroundColor: XelaColor.White,
            color: XelaColor.Blue3,
            outline: 'none',
          }}
          onClick={() => setShowFullContent(!showFullContent)}
        >
          {showFullContent ? 'Show Less' : 'Read More'}
        </div>
      )}
    </div>
  )
}

export default XReadMore
